// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_TestClockAdvanceInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_TestClockAdvanceInput — body for
 * POST /subscriptions/admin/test-clock/{subscription_id}/advance  (S11 · C1).
 *
 * ONE dial, on purpose (user decision, 2026-08-07): "avançar N dias". No
 * target-date form and no boundary shortcuts — a second way to say the same
 * thing is a second way to disagree about what it meant.
 *
 * POSITIVE ONLY. The clock never retreats (spec §non-goals: "Não retrocede"),
 * so a zero or negative `days` is refused here rather than silently no-op'ing.
 *
 * UPPER BOUND. MAX_DAYS is a typo guard, not a policy: 3650 days is ten years,
 * far past any billing scenario worth exercising, and it stops a stray extra
 * digit from shoving a subscription's whole date set into the previous decade
 * — permanently, since the advance is cumulative and there is no rollback.
 */
import { registerContract } from './validate'

export interface Subscriptions_TestClockAdvanceInput {
days: number
}

registerContract('Subscriptions_TestClockAdvanceInput', {
  days: { type: 'number',  required: true },
})
